import { render, staticRenderFns } from "./ConceptAdd.vue?vue&type=template&id=7f6c8b13&scoped=true&"
import script from "./ConceptAdd.vue?vue&type=script&lang=js&"
export * from "./ConceptAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c8b13",
  null
  
)

export default component.exports